import React from 'react';
import { Block } from '@upsales/components';

const EditProductInputWrap = props => <Block space="pbxl" {...props}></Block>;

export default EditProductInputWrap;
